import { jsx as t, jsxs as i, Fragment as _ } from "react/jsx-runtime";
import { useState as v, useRef as V, useEffect as N } from "react";
import { generateUniqueId as T } from "../../lib/generateUniqueId.mjs";
import { fetchBrightcoveData as q, getVideoResourceUrl as y } from "../../lib/fetchBrightcoveData.mjs";
import { formatText as l, formatTime as B } from "../../lib/formatters.mjs";
/* empty css                   */
import f from "xss";
const $ = ({
  accountId: n,
  policyKey: s,
  testId: r,
  playlistId: a,
  className: p,
  videoId: d
}) => {
  const [h, g] = v([]), c = V(!1);
  return N(() => {
    c.current || (c.current = !0, q(
      n,
      s,
      y(d, a)
    ).then((e) => {
      const m = [], u = (o) => {
        const x = {
          ...o,
          uniquePlayerId: T()
        };
        m.push(x);
      };
      Array.isArray(e.videos) ? e.videos.forEach((o) => u(o)) : u(e), g(m);
    }).catch((e) => console.error("Error getVideoInfo", e)));
  }, [d, a, n, s]), /* @__PURE__ */ t("div", { className: p, "data-testid": r || void 0, children: h.map((e) => /* @__PURE__ */ i(
    "div",
    {
      id: `${e.uniquePlayerId}-text-target`,
      className: "video-description-container Content u-textPrimary u-paddingBottom32",
      children: [
        e.name && /* @__PURE__ */ t(
          "h3",
          {
            className: "video-name u-paddingBottom8",
            "data-testid": r ? `${r}-title` : void 0,
            dangerouslySetInnerHTML: { __html: f(l(e.name)) }
          }
        ),
        /* @__PURE__ */ i(
          "p",
          {
            className: "video-description u-colorNeutral",
            "data-testid": r ? `${r}-description` : void 0,
            children: [
              e.long_description && /* @__PURE__ */ i(_, { children: [
                /* @__PURE__ */ t(
                  "span",
                  {
                    dangerouslySetInnerHTML: {
                      __html: f(l(e.long_description))
                    }
                  }
                ),
                " "
              ] }),
              /* @__PURE__ */ t(
                "span",
                {
                  className: "video-duration u-textBold",
                  dangerouslySetInnerHTML: { __html: B(e.duration) }
                }
              )
            ]
          }
        )
      ]
    },
    e.uniquePlayerId
  )) });
};
export {
  $ as VideoDescription
};
//# sourceMappingURL=VideoDescription.mjs.map
